<template>
  <div class="equipe-bars">
    <div class="bar-row" v-for="item in data" :key="item.equipe.value">
      <span class="bar-label">
        <span class="dot" :style="{ background: item.equipe.hex, borderColor: item.equipe.mainColor }"></span>
        <span class="label-text">{{ item.equipe.label }}</span>
      </span>
      <div class="bar-track">
        <div
          class="bar-fill bar-fill-confirmed"
          :style="{ width: percent(item.confirmed, maxTotal), background: item.equipe.hex, color: item.equipe.textColor }"
        >
          <span class="bar-value" v-if="item.confirmed > 0">{{ item.confirmed }}</span>
        </div>
        <div
          class="bar-fill bar-fill-pending"
          :style="{ width: percent(item.pending, maxTotal) }"
        >
          <span class="bar-value bar-value-pending" v-if="item.pending > 0">{{ item.pending }}</span>
        </div>
      </div>
      <span class="bar-total">{{ item.confirmed }}/{{ item.total }}</span>
    </div>

    <div class="chart-legend">
      <span class="legend-item"><span class="legend-dot legend-confirmed"></span> Confirmados</span>
      <span class="legend-item"><span class="legend-dot legend-pending"></span> Pendentes</span>
    </div>
  </div>
</template>

<script>
import { EQUIPES, SEM_EQUIPE } from '../../lib/equipes'

export default {
  name: 'EquipeBars',
  props: {
    acampantes: { type: Array, required: true }
  },
  computed: {
    data() {
      const groups = EQUIPES.map(equipe => {
        const items = this.acampantes.filter(a => a.equipe === equipe.value)
        const confirmed = items.filter(a => a.check).length
        const total = items.length
        return { equipe, confirmed, pending: total - confirmed, total }
      })
      // Incluir "Sem equipe" quando houver acampantes sem equipe definida
      const semEquipe = this.acampantes.filter(a => !a.equipe)
      if (semEquipe.length > 0) {
        const confirmed = semEquipe.filter(a => a.check).length
        groups.push({
          equipe: SEM_EQUIPE,
          confirmed,
          pending: semEquipe.length - confirmed,
          total: semEquipe.length
        })
      }
      return groups.filter(d => d.total > 0)
    },
    maxTotal() {
      return Math.max(1, ...this.data.map(d => d.total))
    }
  },
  methods: {
    percent(value, max) {
      return `${Math.round((value / max) * 100)}%`
    }
  }
}
</script>

<style scoped>
.equipe-bars { display: flex; flex-direction: column; gap: var(--spacing-md); }

.bar-row {
  display: grid;
  grid-template-columns: 110px 1fr 56px;
  align-items: center;
  gap: var(--spacing-md);
}
.bar-label {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--color-text-primary);
}
.dot {
  width: 12px; height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid;
}
.label-text { letter-spacing: 0.3px; }

.bar-track {
  display: flex;
  height: 28px;
  background: var(--color-bg-hover);
  border-radius: var(--radius-md);
  overflow: hidden;
}
.bar-fill {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.5s ease;
  min-width: 0;
}
.bar-fill-pending { background: #ddd; }
.bar-value {
  font-size: var(--text-xs);
  font-weight: 700;
  padding: 0 6px;
  white-space: nowrap;
}
.bar-value-pending { color: var(--color-text-muted); }

.bar-total {
  font-size: var(--text-xs);
  font-weight: 700;
  color: var(--color-text-muted);
  text-align: right;
}

.chart-legend {
  display: flex;
  gap: var(--spacing-base);
  margin-top: var(--spacing-sm);
  padding-top: var(--spacing-md);
  border-top: 1px solid var(--color-bg-separator);
  font-size: var(--text-xs);
  color: var(--color-text-muted);
}
.legend-item { display: inline-flex; align-items: center; gap: var(--spacing-sm); }
.legend-dot { width: 10px; height: 10px; border-radius: 50%; }
.legend-confirmed { background: var(--color-success); }
.legend-pending { background: #ddd; }

@media (max-width: 480px) {
  .bar-row { grid-template-columns: 80px 1fr 48px; gap: var(--spacing-sm); }
  .bar-label { font-size: var(--text-xs); }
}
</style>
